import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box"
import Link from "@material-ui/core/Link"
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ProgressiveImage from './progressiveImage';
import _ from '../../lodash-wrapper';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const useStyles = makeStyles((theme) => ({
    carouselWrapper: {
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
    },
    
    carouselComponent:{
        position: 'relative',
        alignItems:"center" ,
        justifyContent:"center" ,
        overflowX:"hidden",
        height: '510px', width: '1240px',                                                                        // 1280-1920px and above
        [theme.breakpoints.down('md')]: { height: '41vw', width: '100%', marginTop: '-10px', display: 'flex' },  // 960-1279px
        [theme.breakpoints.down('sm')]: { height: '41vw', width: '100%', marginTop: '-10px' },                   // 840-959px
        [theme.breakpoints.down(840)]:  { height: '46vw', width: '100%', marginTop: '-10px' },                   // 720-839px
        [theme.breakpoints.down(720)]:  { height: '48vw', width: '100%', marginTop: '-10px' },                   // 600-719px
        [theme.breakpoints.down('xs')]: { height: '70vw', width: '100%', marginTop: '-10px' },                   // 0-599px
    },

    imgBox: {
        display: "flex",
        overflowX:"hidden",
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        width: '1240px',                                                     // 1280-1920px and above
        [theme.breakpoints.down('md')]: { height: '38vw', width: '94vw' },   // 960-1279px
        [theme.breakpoints.down('sm')]: { height: '38vw', width: '94vw' },   // 840-959px
        [theme.breakpoints.down(840)]:  { height: '38vw', width: '94vw' },   // 720-839px
        [theme.breakpoints.down(720)]:  { height: '38vw', width: '94vw' },   // 600-719px
        [theme.breakpoints.down('xs')]: { height: '66vw', width: '100vw' },  // 0-599px
    },
    
    controlsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 10px',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 100,
        marginTop: '-16px', marginBottom: '5px', height: '40px', gap: '35px',
        [theme.breakpoints.down('md')]: {marginTop: '-26px', marginBottom: '5px', height: '40px'},
        [theme.breakpoints.down('sm')]: {marginTop: '-20px', marginBottom: '5px', height: '38px'},
        [theme.breakpoints.down(840)]: {marginTop: '-50px', marginBottom: '30px', height: '32px', gap: '20px'},
        [theme.breakpoints.down(720)]: {marginTop: '-50px', marginBottom: '30px', height: '32px', gap: '20px'},
        [theme.breakpoints.down('xs')]: {marginTop: '-20px', marginBottom: '1px', height: '38px', gap: '20px'},
    },
    
    dotsContainer: {
        display: 'flex',
        gap: '32px',
        alignItems: 'center',
        [theme.breakpoints.down(840)]: {gap: '30px'},
        [theme.breakpoints.down('xs')]: {gap: '28px'},
    },
    
    customDot: {
        width: '13px', height: '13px',
        [theme.breakpoints.down('sm')]: {width: '11px', height: '11px',},
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        opacity: 0.4,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            opacity: 1,
            transform: 'scale(1.2)',
        },
        '&:hover': {
            opacity: 0.7,
        },
    },
    
    controlArrow: {
        width: '36px',  height: '36px',
        [theme.breakpoints.down('sm')]: {width: '32px', height: '32px',},
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        color: theme.palette.primary.main,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: '1px solid rgba(0, 0, 0, 0.2)',
        outline: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        transition: 'all 0.3s ease',
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
        userSelect: 'none',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            transform: 'scale(1.05)',
        },
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            transform: 'scale(0.95)',
        },
    },
}))

const carouselData = [
    {
        link: '/search?ordering=recommended',
        placeholder: 'img/banner_socrates-placeholder.webp',
        src: 'img/banner_socrates.webp',
        key: 'hok6',
    },
    {
        link: 'https://ko-fi.com/hok6dotcom',
        placeholder: 'img/banner-joinMember-placeholder.webp',
        src: 'img/banner-joinMember.webp',
        key: 'kofi', 
    },
    {
        link: '/terms/discount',
        placeholder: 'img/banner-studentAsianDiscount-placeholder.webp',
        src: 'img/banner-studentAsianDiscount.webp',
        key: 'studentDiscount',
    },
    {
        link: '/become-teacher',
        placeholder: 'img/banner-tobeTeacher-placeholder.webp',
        src: 'img/banner-tobeTeacher.webp',
        key: 'teacher',
    },
    {
        link: '/user/4322',
        placeholder: 'img/banner-corrupted-placeholder.webp',
        src: 'img/banner-corrupted.webp',
        key: 'corrupted',
    },
];



export default function HomeCarousel()
{
    const classes = useStyles();
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = React.useState(0);
        
    const carouselItems = carouselData.map((item, index) => (
        <Link href={item.link} key={item.key}>
            <Box className={classes.imgBox}>
                <ProgressiveImage
                    placeholder={item.placeholder}
                    src={item.src}
                    loading={index === 0 ? "eager" : "lazy"}
                />
            </Box>
        </Link>
    ));

    // Slider settings - disable built-in arrows and dots, use custom controls
    const settings = {
        dots: false, // We'll create custom dots
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 5000, // 5 seconds
        pauseOnHover: true,
        arrows: false, // We'll create custom arrows
        beforeChange: (current, next) => setCurrentSlide(next),
    };

    // Custom navigation functions
    const goToPrev = (e) => {
        e.preventDefault();
        e.stopPropagation();
        sliderRef.current?.slickPrev();
    };

    const goToNext = (e) => {
        e.preventDefault();
        e.stopPropagation();
        sliderRef.current?.slickNext();
    };

    const goToSlide = (index) => {
        sliderRef.current?.slickGoTo(index);
    };

    // Custom dots component
    const CustomDots = () => (
        <div className={classes.dotsContainer}>
            {carouselData.map((_, index) => (
                <div
                    key={index}
                    className={`${classes.customDot} ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                />
            ))}
        </div>
    );

    // Custom controls component
    const CustomControls = () => (
        <div className={classes.controlsContainer}>
            <button
                className={classes.controlArrow}
                onClick={goToPrev}
                onTouchStart={goToPrev}
                onTouchEnd={(e) => e.preventDefault()}
                aria-label="Previous slide"
                type="button"
            >
                <ArrowBackIosIcon style={{ marginLeft: '3px', fontSize: '14px' }} />
            </button>
            
            <CustomDots />
            
            <button
                className={classes.controlArrow}
                onClick={goToNext}
                onTouchStart={goToNext}
                onTouchEnd={(e) => e.preventDefault()}
                aria-label="Next slide"
                type="button"
            >
                <ArrowForwardIosIcon style={{ fontSize: '14px' }} />
            </button>
        </div>
    );
    
    return (
        <div className={classes.carouselWrapper}>
            <Slider
                ref={sliderRef}
                {...settings}
                className={classes.carouselComponent}
            >
                {carouselItems}
            </Slider>
            <CustomControls />
        </div>
    );
}
